import React, { useEffect } from 'react';
import { i18n_skip_ahead_x_seconds } from '@yi/i18n/phrases/i18n_skip_ahead_x_seconds';

import { addForward30SecButton } from './addForward30SecButton';
import { useLocale } from '../../LocaleProvider';
import { useMediaPlayer } from '../MediaPlayerProvider';

export const Forward30SecButton: React.FC = () => {
  const { player } = useMediaPlayer();
  const { locale } = useLocale();

  useEffect(() => {
    if (player !== null) {
      addForward30SecButton(player, {
        title: i18n_skip_ahead_x_seconds(locale, { seconds: 30 }),
      });
    }
  }, [locale, player]);

  return null;
};
